import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {useHistory} from "react-router-dom";
import ConfImpostazioniView from "./ConfImpostazioniView";
import {ParametersContext} from "../../context/ParametersContext";

export default function ConfImpostazioniController() {

    const [parametri, setParametri] = useState([]);

    const {translate} = useContext(TranslateContext);
    const {getParameters} = useContext(ParametersContext);
    const parameters = getParameters();

    const history = useHistory();

    useEffect(() => {
        if (parameters) {
            setParametri(parameters);
        }
    }, [parameters]);

    function onRowDbClickImpostazione(row) {
        history.push(`/upd-parametro/${row.id}`);
    }

    return (
        <ConfImpostazioniView
            data={parametri}
            translate={translate}
            onRowDbClickImpostazione={onRowDbClickImpostazione}
        />
    );
}
